// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"on-z","badgeLink":"pn-z","category":"qn-z"};